import "./Logo.css";

const Logo = () => {
    return (
        <div className="logo">
            <a href="/"><img src="/logo.svg" alt="logo"/></a>
            <span><a href="/">IPTV</a></span>
        </div>
    );
};

export default Logo;
